import {createAction, createReducer} from '@reduxjs/toolkit';

import {completeOrderReview} from '../../../actions/completeOrder/completeOrder';
import {savePayment} from '../savePaymentData/savePaymentData';

export type ApplePayType = {
    loading: boolean;
    errorMessage: string | null;
};
export const initialState: ApplePayType = {
    errorMessage: null,
    loading: false,
};

export const saveApplePayPayment = createAction<{token: string}>('CHECKOUT@APPLEPAY@SAVE');

export const setLoadingApplePay = createAction<boolean>('CHECKOUT@APPLEPAY@SET_LOADING');

export const setApplePayInnerError = createAction<string>('CHECKOUT@APPLEPAY@SET_ERROR');

export const applePay = createReducer(initialState, builder =>
    builder
        .addCase(setLoadingApplePay, (state, action) => ({...state, loading: action.payload}))
        .addCase(savePayment.rejected, state => ({
            ...state,
            loading: false,
        }))
        .addCase(completeOrderReview.rejected, state => ({
            ...state,
            loading: false,
        }))
        .addCase(completeOrderReview.fulfilled, state => ({
            ...state,
            loading: false,
        }))
        .addCase(setApplePayInnerError, (state, action) => ({
            ...state,
            errorMessage: action.payload,
        })),
);
